export const launchdarklyFlags = {
  analyticsDashboard: false,
  'boost-demo': false,
  boostDemo: false,
  detachWindowMode: false,
  countdownTimer: false,
  demoPageDemostackingTab: false,
  'desktop-app-user-agent': {
    'default-mac':
      'Mozilla/5.0 (Macintosh; Intel Mac OS X 14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/118.0.0.0 Safari/537.36',
    'default-win':
      'Mozilla/5.0 (Windows NT 10.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/118.0.0.0 Safari/537.36',
    'demo.impact.com':
      'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/109.0.0.0 Mobile Safari/537.36',
    'go.thryv.com':
      'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/109.0.0.0 Mobile Safari/537.36',
    'login.rxauditor.com':
      'Mozilla/5.0 (Linux; Android 6.0; Nexus 5 Build/MRA58N) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/109.0.0.0 Mobile Safari/537.36',
    'workforcenow.adp.com':
      'Mozilla/5.0 (Macintosh; Intel Mac OS X 13_4) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36',
  },
  desktopAppCacheAssetsInMemory: false,
  desktopAppCacheScripts: false,
  desktopAppHideUrl: false,
  desktopAppLocalServer: false,
  desktopAppMinimumVersion: '',
  desktopAppShowSaveAndExitButton: false,
  desktopAppDisableSignalRWebSockets: false,
  desktopAppDisableWebSocketAPI: false,
  'desktop-personas': false,
  desktopServerTiming: false,
  forceDevTools: false,
  integrations: false,
  noDragDomains: {
    domains: ['https://app.slack.com/'],
  },
  platformPrideLogo: false,
  platformSpliceFromClone: false,
  platformUpdateCloneTimeLimit: 0,
  platformWorkspaces: false,
  refreshPageButton: false,
  skipCapturePage: [
    'LoginContinued?',
    'demoaccess.paylocity.com/SignIn',
    'online.adp.com',
    'app.coachhub.io',
    'app.coachhub.com',
    '35.142.120.231:8888',
    'yapi.auth0.com',
    'trackerprodemo.ryan.com',
    'https://authentication-management.service.imperva.com/login',
    'management.service.imperva.com/',
  ],
  'skip-intercept-request': ['https://chicago.goguardian.com/v1/events'],
  toggleSpeakerViewShare: false,
  toursPresentInDemostacking: false,
  toursShareAspectRatio: false,
  desktopAppMonitoring: false,
  sandboxMobileView: false,
  desktopResetSettings: false,
  autoCrawlerByDomain: { 'app.frdm.co': true },
  desktopAppDisabledHighchartsDomains: ['sde.mistnet.io'],
  enhancedDemostackingLimits: false,
  desktopAppForceWebSecurity: ['demofusion.exabeam.cloud'],
  overrideWindowClose: false,
  desktopAppTableCraftRightClick: false,
  desktopAppClonePopupEnabledList: [
    'https://login.microsoftonline.com/',
    'https://accounts.google.com/',
    'https://app.topopps.com/oauth_start/',
  ],
  speakerPanelNew: false,
  multiTabDisplay: false,
  desktopAppForceNewSessionList: [
    'https://securityinnovation.box.com/s/',
    'https://securityinnovation.app.box.com/s/',
  ],
  cloneScreenRecording: false,
  editorSpotEdits: false,
  desktopAppAllowInsecureBrowsing: false,
  enableDeltekRepliconWebsocket: false,
  desktopAppPreventClonePageReload: false,
};
